import React from 'react';
import usePermission from '../../../utils/hooks/permissionHooks/usePermission';
import {
  IEntityCategoryFieldsFragment,
  PermissionKey,
} from '../../../utils/apollo/graphqlSchema';
import EntityCategories from './EntityCategories';
import EntityCategoriesList from './EntityCategoriesList';

interface IProps {
  schemaId: string;
  entityCategories: IEntityCategoryFieldsFragment[];
  isDisabled?: boolean;
  onApply?: (selectedCategories: string[], isManaged: boolean) => Promise<void>;
  isManaged?: boolean;
}

const EntityCategoriesController = ({
  schemaId,
  isDisabled,
  entityCategories,
  onApply,
  isManaged,
}: IProps) => {
  const { checkIsPermitted } = usePermission();
  const isPermittedToReadCategory = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.CategoryRead],
    schemaId,
  });
  const isPermittedToCreateCategory = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.CategoryCreate],
    schemaId,
  });

  if (!isPermittedToReadCategory) {
    return <div />;
  }

  if (isDisabled) {
    return (
      <EntityCategoriesList
        entityCategories={entityCategories}
        disabled={true}
        isManaged={isManaged}
      />
    );
  }

  return (
    <EntityCategories
      schemaId={schemaId}
      entityCategories={entityCategories}
      onApply={onApply}
      isPermittedToCreateCategory={isPermittedToCreateCategory}
      isManaged={isManaged}
    />
  );
};

export default EntityCategoriesController;
